function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVanchangerLogoNebelblau(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 75099 84023",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M68655.4,21438c0,-0 -28842.8,-16652.3 -28842.8,-16652.3c-1400.72,-808.815 -3126.55,-808.815 -4527.27,-0l-28842.8,16652.3c-1400.72,808.814 -2263.72,2303.33 -2263.72,3920.79l0,33304.8c0,1617.47 863,3111.97 2263.72,3920.79l28842.8,16652.3c1400.72,808.814 3126.55,808.814 4527.27,-0l28842.8,-16652.3c1400.72,-808.815 2263.55,-2303.32 2263.55,-3920.79l-0,-33304.8c-0,-1617.45 -862.831,-3111.97 -2263.55,-3920.79Zm-26753.2,-20271.5c-2693.76,-1555.39 -6012.52,-1555.39 -8706.44,-0l-28842.5,16652.3c-2693.76,1555.21 -4353.23,4429.53 -4353.23,7539.92l0,33304.8c0,3110.43 1659.47,5984.75 4353.23,7539.92l28842.5,16652.3c2693.93,1555.39 6012.69,1555.39 8706.44,0l28842.8,-16652.3c2693.76,-1555.21 4353.23,-4429.53 4353.23,-7539.92l-0,-33304.8c-0,-3110.43 -1659.47,-5984.75 -4353.23,-7539.92l-28842.8,-16652.3Z",
    style: {
      fill: "#3a536b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33215.1,43103.3l-9578.23,-0l-6808.99,-19723.9l10112.5,0l6274.69,19723.9Z",
    style: {
      fill: "#3a536b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34323,46586l3024.35,9506.89l399.518,-0l3030.36,-9506.89l9489.19,-0l-6843.12,19850.7l-11731.5,0l-6852.71,-19850.7l9483.92,-0l-0.025,-0Z",
    style: {
      fill: "#3a536b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51466.9,43103.3l-9579.56,-0l6287.39,-19723.9l10091.6,0l-6799.39,19723.9Z",
    style: {
      fill: "#3a536b"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVanchangerLogoNebelblau);
export default __webpack_public_path__ + "static/media/vanchanger_logo_nebelblau.435457c1da1adb75279a5556b6fc8f67.svg";
export { ForwardRef as ReactComponent };